<template>
  <article class="warpH">
    <section class="carQrCode-box" v-if="success">
      <div class="status-icon carQrCode-done"></div>
      <div class="status-mes">您已接手车辆{{plateNumber}}</div>
    </section>
    <section class="carQrCode-box" v-if="failure">
      <div class="status-icon carQrCode-failure"></div>
      <div class="status-mes">{{message}}</div>
    </section>
    <section class="carQrCode-box" v-if="busy">
      <div class="status-icon carQrCode-serverBusy"></div>
      <div class="status-mes">服务器繁忙，请稍后重试</div>
    </section>
    <footer class="footer" v-if="!isDOS">
      <em class="icon-logo-zs"></em>中升集团
    </footer>
  </article>
</template>
<script>
export default {
  data() {
    return {
      busy: false,
      success: false,
      failure: false,
      message: '',
      plateNumber: ''
    }
  },
  created() {
    this.$rest.carQrCode.getToken().then((res) => {
      if (res.code === 0) {
        this.getInfo()
      }
    })
  },
  methods: {
    getInfo() {
      let serveCarId = this.$route.params.serveCarId
      if (serveCarId) {
        this.$rest.carQrCode.saveQrCodeInfo(null, serveCarId).then((res) => {
          if (res.code === 0) {
            this.plateNumber = res.data.plate_number
            this.success = true
          } else {
            this.message = res.message
            this.failure = true
          }
        }, (res) => {
          if (res.status === 500) {
            this.busy = true
          }
        })
      }
    }
  },
  computed: {
    isDOS() {
      return this.$store.state.isDOS
    }
  }
}
</script>
<style lang="less">
@w2: 75rem;
.warpH {
  height: 100%;
  background: #FFF;
  overflow: hidden;
  .carQrCode-box {
    text-align: center;
  }
  .status-icon {
    width: 150/@w2;
    height: 150/@w2;
    background: url('../../stylesheets/images/icon.png') no-repeat;
    background-size: 600/@w2 auto;
    margin: 75/@w2 auto;
  }
  .status-mes {
    font-size: 30/@w2;
  }
  .carQrCode-done {
    background-position: 0 0;
  }
  .carQrCode-serverBusy {
    background-position: -450/@w2 -450/@w2
  }
  .carQrCode-failure {
    background-position: -273/@w2 -450/@w2
  }
}
</style>
